export default function ContactSection() {
  return (
    <>
      {/* Section spacer */}
      <div className="cinematic-section-spacer"></div>
      
      <section id="contact" className="py-20" style={{ backgroundColor: '#1c1208' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2
              className="text-4xl lg:text-5xl font-bold mb-6"
              style={{ color: '#F5F3EF' }}
            >
              Contact & Connect
            </h2>
            <p className="text-lg mx-auto whitespace-normal break-words md:whitespace-nowrap" style={{ letterSpacing: '0.01em', color: '#F5F3EF', opacity: 0.8 }}>
              If you're not sure about booking yet, feel free to send me a drawing — I'll be happy to share my feedback.
            </p>
          </div>

          {/* Contact Details - Horizontal on Desktop, Vertical on Mobile */}
          <div className="flex flex-col lg:flex-row lg:justify-center gap-6 lg:gap-8">
            {/* WhatsApp */}
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-8 flex items-center lg:flex-1 lg:max-w-xs">
              <a href="https://wa.me/66948203500" className="w-12 h-12 cinematic-accent-bg rounded-full flex items-center justify-center mr-4 hover:cinematic-accent-hover transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-whatsapp-line text-xl text-white"></i>
              </a>
              <div>
                <p className="font-medium cinematic-text-dark">WhatsApp</p>
                <a href="https://wa.me/66948203500" className="cinematic-accent hover:text-amber-700 cursor-pointer">
                  +66 94 820 3500
                </a>
              </div>
            </div>

            {/* Instagram */}
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-8 flex items-center lg:flex-1 lg:max-w-xs">
              <a href="https://www.instagram.com/yuvati_art/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 cinematic-accent-bg rounded-full flex items-center justify-center mr-4 hover:cinematic-accent-hover transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-instagram-line text-xl text-white"></i>
              </a>
              <div>
                <p className="font-medium cinematic-text-dark">Instagram</p>
                <a href="https://www.instagram.com/yuvati_art/" target="_blank" rel="noopener noreferrer" className="cinematic-accent hover:text-amber-700 cursor-pointer">
                  @yuvati_art
                </a>
              </div>
            </div>

            {/* Telegram */}
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-8 flex items-center lg:flex-1 lg:max-w-xs">
              <a href="https://t.me/YuvatiArt" className="w-12 h-12 cinematic-accent-bg rounded-full flex items-center justify-center mr-4 hover:cinematic-accent-hover transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-telegram-line text-xl text-white"></i>
              </a>
              <div>
                <p className="font-medium cinematic-text-dark">Telegram</p>
                <a href="https://t.me/YuvatiArt" className="cinematic-accent hover:text-amber-700 cursor-pointer">
                  @Yuvatiart
                </a>
              </div>
            </div>

            {/* Email */}
            <div className="bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 p-8 flex items-center lg:flex-1 lg:max-w-xs">
              <a href="mailto:yuvati.art@gmail.com" className="w-12 h-12 cinematic-accent-bg rounded-full flex items-center justify-center mr-4 hover:cinematic-accent-hover transition-colors cursor-pointer flex-shrink-0">
                <i className="ri-mail-line text-xl text-white"></i>
              </a>
              <div>
                <p className="font-medium cinematic-text-dark">Email</p>
                <a href="mailto:yuvati.art@gmail.com" className="cinematic-accent hover:text-amber-700 cursor-pointer">
                  yuvati.art@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
